module.exports = __webpack_public_path__ + "static/media/2 (37).57725674.jpg";